module.exports = __webpack_public_path__ + "static/media/Mark.93913410.svg";